module.exports = __webpack_public_path__ + "img/lyal_b2.5d3de14f.jpg";